import React, { useEffect, useState } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import { PrevBtn, NextBtn, PaginationWrapper } from "../Styles/PageStyles";
import moment from "moment";
import Images from "../../Images";
import tw from "tailwind-styled-components";
import { PaginationLimit } from "../../Config";

const Table = ({ ApiData }) => {
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);


  const getDate = (item) => {
    return (
      <div className="flex gap-3 ">
        <div className="flex flex-col ">
          <span className="text-zinc-900 font-medium">
            {item.date
              ? moment(item.date).format("ll")
              : "---"}
          </span>
        </div>
      </div>
    );
  };

 const getExistRecord = (item) => {
  return (
    <div className="text-zinc-900 text-sm leading-6">
      {item.summary}
    </div>
  );
};

// const getRentCount = (item) => {
//   return (
//     <div className="text-sm font-medium text-blue-600">
//       {item.rent_added_count ?? "-"}
//     </div>
//   );
// };


 
useEffect(() => {
  if (ApiData && ApiData.length > 0) {
    const formatted = ApiData.map((item) => ({
      _raw: item,
      date: getDate(item),
      summary: getExistRecord(item),
      // rent_added_count: getRentCount(item),
    }));

    setData(formatted);
  } else {
    setData([]);
  }
}, [ApiData]);

 

  useEffect(() => {
    const handleResize = () =>
      setIsMobileView(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () =>
      window.removeEventListener("resize", handleResize);
  }, []);

  const columns = React.useMemo(() => {
    if (isMobileView) {
      return [
        { Header: "Date", accessor: "date" },
        { Header: "Summary", accessor: "summary" },
      ];
    }

    return [
      { Header: "Date", accessor: "date" },
      { Header: "Summary", accessor: "summary" },
      // { Header: "Rent Added", accessor: "rent_added_count" },
    ];
  }, [isMobileView]);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    pageOptions,
    state: { pageIndex },
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
  } = useTable(
    {
      data,
      columns,
      initialState: {
        pageIndex: currentPage,
        pageSize: PaginationLimit,
      },
    },
    useSortBy,
    usePagination
  );

  useEffect(() => {
    setCurrentPage(pageIndex);
  }, [pageIndex]);

  return (
    <>
      <CustomTable {...getTableProps()}>
        <Thead>
          {headerGroups.map((headerGroup) => (
            <Tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <Th {...column.getHeaderProps(column.getSortByToggleProps())}
                >
                  {column.render("Header")}
                  <span>
                    {column.isSorted ? (
                      <img
                        src={Images.Arrow}
                        alt="down arrow"
                        className={`${column.isSortedDesc ? "-rotate-90" : "rotate-90"
                          } w-1.5 inline-block ml-1.5`}
                      />
                    ) : (
                      ""
                    )}
                  </span>
                </Th>
              ))}
            </Tr>
          ))}
        </Thead>
        <Tbody
          {...getTableBodyProps()}
          className={ApiData?.length > 0 ? "border-b" : ""}
        >
          {page.map((row, rowIndex) => {
            prepareRow(row);
            return (
              <React.Fragment key={rowIndex}>
                <Tr
                  {...row.getRowProps()}
                  className={ApiData?.length > 0 ? "border-b" : ""}
                >
                  {row.cells.map((cell, cellIndex) => {
                    return (
                      <Td
                        {...cell.getCellProps()}
                      >
                        {cell.render("Cell")}
                      </Td>
                    );
                  })}
                </Tr>
              </React.Fragment>
            );
          })}
        </Tbody>
      </CustomTable>

      {ApiData?.length > 0 && (
        <PaginationWrapper>
          <div className="px-2">
            Page <em>{pageIndex + 1} of {pageOptions.length}</em>
          </div>
          <div className="flex gap-1">
            <PrevBtn onClick={previousPage} disabled={!canPreviousPage}>
              <img src={Images.Arrow} alt="arrow" className="w-2 opacity-75" />
            </PrevBtn>
            <NextBtn onClick={nextPage} disabled={!canNextPage}>
              <img src={Images.Arrow} alt="arrow" className="w-2 rotate-180 opacity-75" />
            </NextBtn>
          </div>
        </PaginationWrapper>
      )}
    </>
  );
};

const CustomTable = tw.table`w-full text-zinc-600`;
const Thead = tw.thead`border-b uppercase text-zinc-500 bg-slate-100`;
const Tbody = tw.tbody`${(p) => (p.hasdata === "true" ? "border-b" : "")}`;
const Tr = tw.tr`${(p) =>
  p.hasdata === "true" ? "border-b" : ""} hover:bg-slate-50`;
const Th = tw.th`text-left text-sm md:p-3 p-0.5 font-medium text-gray-500 cursor-pointer`;
const Td = tw.td`p-3 text-sm md:p-3 text-left`;

export default Table;